import { render } from "./ArtistWishlists.vue?vue&type=template&id=385f198c"
import script from "./ArtistWishlists.vue?vue&type=script&lang=js"
export * from "./ArtistWishlists.vue?vue&type=script&lang=js"

import "./ArtistWishlists.vue?vue&type=style&index=0&id=385f198c&lang=scss"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__